<template>
    <div>
        <v-layout fill-height>
            <v-flex sm6 class="overflow-auto">
                  <v-container>
                    <v-text-field v-model="BaseUrl">      
                        <template #append-outer>
                            <v-btn icon @click="downloadUrl"><v-icon>mdi-download</v-icon></v-btn>
                        </template>
                    </v-text-field>      
                </v-container>
            </v-flex>
        </v-layout>
        <v-layout class="main-container" fill-height >

                <v-container class="version-container">
                    <h2 class="title">WORK ITEM</h2>
                    <input class="search" v-model="searchText" placeholder="Search here" />
                    <v-col  md="1">
                        <v-row  class="" v-for="obj in filteredItems" :key="obj">         
                            <v-btn   
                            dark
                            color="indigo"
                            class="mx-2" 
                            @click="getNumVersions(obj)">
                                {{obj}}</v-btn>
                        </v-row>
                    </v-col>
                </v-container> 
                <v-container class="Numversion-container">
                    <v-col   md="1">
                        
                        <h2 class="title">VERSION</h2>

                        <v-row v-for="items in this.numVersions" :key="items">         
                            <v-btn 
                            class="mx-2"
                           
                            dark
                            color="teal"
                            @click="showJson(items.offset)">
                            {{items.num}}</v-btn>
                        </v-row>
                    </v-col>
                </v-container>   
                <v-container class="json-container">
                        <v-col md="100">

                            <p v-if="!offsetJson" class="title"> ورژن را انتخاب نمایید</p>        
                            <v-row v-if="offsetJson" > 
                               <vue-json-pretty :data="offsetJson" />
                            </v-row>
                        </v-col>
                </v-container>        
        </v-layout>
    </div>
</template> 
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
    export default 
    {
        components: {
            VueJsonPretty,
        },
        name: 'DefVersion',
        data:()=>({
            BaseUrl:"/proxy/https:day-develop.karestanjavan.ir/v1/def/$repository",
            //resultRepository:[{"offset":18588,"ver":"Ali:1","fileName":"Root.Schema.1.json"},{"offset":2,"ver":"Saba:1","fileName":"Root.Schema.1.json"},{"offset":3,"ver":"Saba:2","fileName":"SchemaAttribute.Schema.2.json"},{"offset":1,"ver":"sana:3","fileName":"Root.Root.3.json"}],
            resultRepository:[],
            Versions:[],
            numVersions:[],
            offsetJson: null,
            searchText : "",
        }),
        async created () {
            await this.downloadUrl()
        },
        computed: {
             filteredItems() {
      if (this.searchText === '') {
            
        return this.Versions;
      } else {
        // Filter the array based on the search text
        return this.Versions.filter((item) =>
          item.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
    },
        },
        methods:
        {
            async downloadUrl(){
                const result = await fetch(this.BaseUrl)               
                if (result.ok) {  
                    this.resultRepository = await result.json() 
                    console.log(this.resultRepository)} 
                else {this.error = await result.text()}
                console.log(this.resultRepository , "@@@@@@@@@@@@@@")
                this.resultRepository.reverse()
                for( var items of this.resultRepository)
                {
                   if (!this.Versions.includes(items.ver.split(':').shift()))
                   {
                    this.Versions.push(items.ver.split(':').shift())
                   }
                }
                console.log("versions",this.Versions)
            } ,
            async getNumVersions(item)
            {
                this.numVersions=[]
                console.log("versionsthis.resultRepository.ver",this.resultRepository)
                var version=this.resultRepository.filter((p) => p.ver.split(':').shift()===item)
                for(var items of version)
                {
                    this.numVersions.push( {num: items.ver.split(':').pop(), offset:items.offset})
                }
                this.numVersions=this.numVersions.reverse();
                console.log("numVersions",this.numVersions)
            },
            async showJson(item)
            {
                const result = await fetch("/proxy/https:day-develop.karestanjavan.ir/v1/def/"+item)   
                let resp;
                if (result.ok) {  
                    resp =  await result.json() 
                } 
                else {this.error = await result.text()}
                console.log(JSON.stringify(resp))
                this.offsetJson = resp;

            }
        }
    }
</script>
<style scoped>
.v-btn{
    width: 30px;
}
.mx-2 {
    width: 120px;
    margin: 5px;
}
.main-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
.json-container {
    flex : 5 ;
    height: 70vh;
    overflow: auto;
    border: 1px solid #b7b7b7;
    border-radius: 5px;
}
.version-container {
    flex : 1.2 ;
    align-items: center;
    height: 70vh;
    overflow: auto;
    justify-content: center;
    margin: 0 auto

}
.Numversion-container {
    justify-content: center;
    align-items: center;
    flex : 1.2 ;
    height: 70vh;
    overflow: auto;
}
.title {
    margin: 5px;
}
.search {
    margin: 5px;
}

</style>